import { useEffect } from 'react'

const APP_VERSION = import.meta.env.VITE_VERSION

const LOCAL_STORAGE_VERSION_KEY = '__app_version__'

export const useInitApp = () => {
    useEffect(() => {
        const storedVersion = localStorage.getItem(LOCAL_STORAGE_VERSION_KEY)

        if (storedVersion !== APP_VERSION) {
            console.warn(`App version changed: "${storedVersion}" → "${APP_VERSION}". Clearing localStorage.`)
            localStorage.clear()
            localStorage.setItem(LOCAL_STORAGE_VERSION_KEY, APP_VERSION ?? '')
            window.location.reload()
        }
    }, [])
}
